<template>
  <div class="h-100 position-absolute root w-100">
    <div class="align-items-center bg-dark bg-opacity-50 d-none fixed-top h-100 justify-content-center loading w-100" ref="loading">
      <Pulse-Loader :loading="loading"></Pulse-Loader>
    </div>
    
    <nav class="navbar p-4">
      <div class="container-fluid">
        <router-link
          exact
          title="Voltar"
          to="/filter"

          v-if="this.state.userType !== 'Paciente' && this.state.userType !== 'PacienteCpf' && this.state.userType !== 'tulValidaHash'"
          v-b-tooltip.hover
        >
          <svg height="30" viewBox="0 0 16 16" width="30">
            <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
          </svg>
        </router-link>
        <div>
          <button
            :id="this.state.userType"
            
            class="border-0 btn me-3 p-0 shadow-none"
            ref="r_pass"
            title="Redefinir a senha de acesso"

            v-b-tooltip.hover
            v-if="this.state.userType != 'tulPaciente' && this.state.userType != 'tulValidaHash' && !isButtonDisabled"

            @click="passwordModal = true;"
          >
            <svg height="28" viewBox="0 0 330 330" width="28">
              <path d="M65,330h200c8.284,0,15-6.716,15-15V145c0-8.284-6.716-15-15-15h-15V85c0-46.869-38.131-85-85-85S80,38.131,80,85v45H65c-8.284,0-15,6.716-15,15v170C50,323.284,56.716,330,65,330z M180,234.986V255c0,8.284-6.716,15-15,15s-15-6.716-15-15v-20.014c-6.068-4.565-10-11.824-10-19.986c0-13.785,11.215-25,25-25s25,11.215,25,25C190,223.162,186.068,230.421,180,234.986z M110,85c0-30.327,24.673-55,55-55s55,24.673,55,55v45H110V85z"/>
            </svg>
          </button>

          <a
            class="border-0 btn p-0 shadow-none"
            href="./"
            title="Sair"

            v-b-tooltip.hover
            v-on:click="logout"
          >
            <svg height="35" viewBox="0 0 16 16" width="35">
              <path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"/>
              <path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
            </svg>
          </a>
        </div>
      </div>
    </nav>

    <b-modal
      :centered="examsListModal.centered"
      :hideHeaderClose="examsListModal.hideHeaderClose"
      :noCloseOnBackdrop="examsListModal.noCloseOnBackdrop"
      :size="examsListModal.size"
      :title="examsListModal.title"

      content-class="user-select-none"
      footer-class="border-0 p-2"
      header-class="bg-light border-bottom px-4 py-3"
      v-model="examsModal"
    >
      <template #modal-header>
        <div class="align-items-center d-flex">
          <svg height="16" style="fill: #000 !important;" width="16" viewBox="0 0 16 16">
            <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053.918 3.995.78 5.323 1.508 7H.43c-2.128-5.697 4.165-8.83 7.394-5.857q.09.083.176.171a3 3 0 0 1 .176-.17c3.23-2.974 9.522.159 7.394 5.856h-1.078c.728-1.677.59-3.005.108-3.947C13.486.878 10.4.28 8.717 2.01zM2.212 10h1.315C4.593 11.183 6.05 12.458 8 13.795c1.949-1.337 3.407-2.612 4.473-3.795h1.315c-1.265 1.566-3.14 3.25-5.788 5-2.648-1.75-4.523-3.434-5.788-5"/>
            <path d="M10.464 3.314a.5.5 0 0 0-.945.049L7.921 8.956 6.464 5.314a.5.5 0 0 0-.88-.091L3.732 8H.5a.5.5 0 0 0 0 1H4a.5.5 0 0 0 .416-.223l1.473-2.209 1.647 4.118a.5.5 0 0 0 .945-.049l1.598-5.593 1.457 3.642A.5.5 0 0 0 12 9h3.5a.5.5 0 0 0 0-1h-3.162z"/>
          </svg>
          <h5 class="m-0 ms-3">
            Exames
          </h5>
        </div>
      </template>
      <div class="px-2" v-if="$signedOnly !== 'true' || unsignedAvailable">
        <div class="border-bottom d-flex py-2" v-for="(exame) in examsList">
          {{ exame.descricao }}
          <div class="col-4 fw-light ms-auto px-2 py-1 rounded text-bg-primary text-center" v-if="exame.status === 'Digitado'">
            Digitado
          </div>
          <div class="col-4 fw-light ms-auto px-2 py-1 rounded text-bg-success text-center" v-else-if="exame.status === 'Liberado'">
            Liberado
          </div>
          <div class="col-4 fw-light ms-auto px-2 py-1 rounded text-bg-warning text-center" v-else-if="exame.status === 'MaterialFaltante'">
            Material faltante
          </div>
          <div class="col-4 fw-light ms-auto px-2 py-1 rounded text-bg-danger text-center" v-else>
            {{ exame.status }}
          </div>
        </div>
      </div>
      <div class="px-2" v-else>
        <div class="border-bottom d-flex py-2" v-for="(exame) in examsList">
          {{ exame.descricao }}
          <div class="col-4 fw-light ms-auto px-2 py-1 rounded text-bg-danger text-center" v-if="exame.status === 'Em andamento'">
            Em andamento
          </div>
          <div class="col-4 fw-light ms-auto px-2 py-1 rounded text-bg-success text-center" v-else>
            Liberado
          </div>
        </div>
      </div>
      <template #modal-footer>
        <button class="btn btn-outline-primary-color btn-sm shadow-none" @click="examsModal = false; getReport(laudoList);" v-if="$signedOnly !== 'true' || (unsignedAvailable && $downloadUnsigned === 'true')">
          Visualizar o laudo
        </button>
        <button class="border-0 btn btn-primary-color btn-sm shadow-none text-white" @click="examsModal = false;">
          Fechar
        </button>
      </template>
    </b-modal>

    <b-modal
      :centered="passwordChangeModal.centered"
      :hideHeaderClose="passwordChangeModal.hideHeaderClose"
      :noCloseOnBackdrop="passwordChangeModal.noCloseOnBackdrop"
      :size="passwordChangeModal.size"
      :title="passwordChangeModal.title"

      content-class="user-select-none"
      footer-class="border-0 p-2"
      header-class="bg-light border-bottom px-4 py-3"
      v-model="passwordModal"
    >
      <template #modal-header>
        <div class="align-items-center d-flex">
          <svg height="16" style="fill: #000 !important;" viewBox="0 0 16 16" width="16">
            <path d="M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2M3 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z"/>
          </svg>
          <h5 class="m-0 ms-3">
            Redefini&ccedil;&atilde;o de senha
          </h5>
        </div>
      </template>
      <form @submit.prevent="changePassword()" class="align-items-center d-flex flex-column py-3">
        <input
          class="border border-2 m-0 mb-2 p-3 rounded-2 text-center"
          id="current-password"
          placeholder="Senha atual"
          ref="currentPassword"
          required
          type="password"
        />
        <input
          class="border border-2 m-0 mb-2 p-3 rounded-2 text-center"
          id="new-password"
          placeholder="Nova senha"
          ref="newPassword"
          required
          type="password"
        />
        <input
          class="border border-2 m-0 mb-2 p-3 rounded-2 text-center"
          id="confirm-password"
          placeholder="Confirmação da nova senha"
          ref="confirmPassword"
          required
          type="password"
        />
        <input
          class="border-0 m-0 mb-3 p-3 rounded-2 text-uppercase text-white"
          type="submit"
          value="Atualizar senha"
        />
      </form>
      <template #modal-footer>
        <button class="border-0 btn btn-primary-color btn-sm shadow-none text-white" @click="passwordModal = false;">
          Fechar
        </button>
      </template>
    </b-modal>

    <b-modal
      :centered="reportsListModal.centered"
      :hideHeaderClose="reportsListModal.hideHeaderClose"
      :noCloseOnBackdrop="reportsListModal.noCloseOnBackdrop"
      :scrollable="reportsListModal.scrollable"
      :size="reportsListModal.size"
      :title="reportsListModal.title"

      content-class="user-select-none"
      footer-class="border-0 p-2"
      header-class="bg-light border-bottom px-4 py-3"
      v-model="reportsModal"
    >
      <template #modal-header>
        <div class="align-items-center d-flex">
          <svg height="16" style="fill: #000 !important;" width="16" viewBox="0 0 16 16">
            <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z"/>
            <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z"/>
            <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5"/>
          </svg>
          <h5 class="m-0 ms-3">
            Hist&oacute;rico de laudos
          </h5>
        </div>
      </template>
      <b-alert variant="info" show>
        <h6 class="alert-heading m-0">
          Estamos de acordo com a ICP-Brasil e a RDC 786 de 05 de maio de 2023
        </h6>
        <p class="m-0">
          Os laudos apresentados abaixo s&atilde;o vers&otilde;es do laudo definitivo emitidos anteriormente.
        </p>
        <p class="m-0 mt-2">
          Considere atualizado o primeiro laudo da lista
        </p>
      </b-alert>
      <div class="align-items-center border-bottom py-2 d-flex" v-for="(report) in reportsList">
        <div class="col-3 col-md-2 fw-light px-2 py-1 rounded text-bg-success text-center" v-if="report.assinado === true">
          Assinado
        </div>
        <div class="col-3 col-md-2 fw-light px-2 py-1 rounded text-bg-danger text-center" v-else>
          Pendente
        </div>
        <div class="d-none d-lg-block ps-5">
          <p class="m-0 p-0">
            Gerado em
          </p>
          <p class="fw-light m-0 mb-3 mb-md-0">
            {{ report.datahora_geracao }}
          </p>
        </div>
        <div class="d-none d-md-block ps-5">
          <p class="m-0 p-0">
            Assinado em
          </p>
          <p class="fw-light m-0 mb-3 mb-md-0" v-if="report.assinado === true">
            {{ report.datahora_assinatura }}
          </p>
          <p class="fw-light m-0 mb-3 mb-md-0" v-else>
            Pendente assinatura
          </p>
        </div>
        <div class="align-items-center d-flex ms-auto">
          <button class="border-0 btn btn-primary-color btn-sm shadow-none text-white" @click="setExamsList(report.exames);">
            Exames no laudo
          </button>
          <button class="border-0 btn btn-primary-color btn-sm ms-2 shadow-none" @click="reportsModal = false; getReport(report);">
            <svg fill="currentColor" height="16" width="16" viewBox="0 0 16 16">
              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
            </svg>
          </button>
        </div>
      </div>
      <template #modal-footer>
        <button class="border-0 btn btn-primary-color btn-sm shadow-none text-white" @click="reportsModal = false;">
          Fechar
        </button>
      </template>
    </b-modal>

    <b-modal
      :centered="popupListModal.centered"
      :hideHeaderClose="popupListModal.hideHeaderClose"
      :noCloseOnBackdrop="popupListModal.noCloseOnBackdrop"
      :size="popupListModal.size"
      :title="popupListModal.title"

      content-class="user-select-none"
      footer-class="border-0 p-2"
      header-class="bg-light border-bottom px-4 py-3"
      v-model="popupModal"
    >
      <template #modal-header>
        <div class="align-items-center d-flex text-center">
          <h5 class="m-0 ms-3">
            {{  $laboratory  }} informa
          </h5>
        </div>
      </template>
      <div class="px-4">
        <p class="m-0 text-justify">
          N&atilde;o foi poss&iacute;vel realizar a abertura do laudo devido &agrave; permiss&otilde;es do seu navegador. Utilize o bot&atilde;o abaixo para abri-lo de forma manual.
        </p>
      </div>
      <template #modal-footer>
        <button class="btn btn-outline-primary-color btn-sm shadow-none" @click="popupModal = false; openReport();">
          Visualizar o laudo
        </button>
        <button class="border-0 btn btn-primary-color btn-sm shadow-none text-white" @click="popupModal = false;">
          Fechar
        </button>
      </template>
    </b-modal>

    <div class="col-11 col-lg-9 col-md-10 col-xl-6 m-auto">
      <div class="fadeIn first">
        <img alt="Laborat&oacute;rio" class="col-6 col-lg-4 col-md-5 mb-3" src="assets/logo.png"/>
      </div>
      <div class="col-12 d-block fadeIn mt-0 second text-center">
        <small>
          {{ this.$version }}
        </small>
      </div>
    </div>

    <hr class="border-light-subtle col-10 col-md-9 col-lg-9 col-xl-8 fadeIn mx-auto second">

    <div class="align-items-center col-11 col-md-10 col-lg-9 col-xl-8 d-md-flex fadeIn mt-5 mb-4 mx-auto p-0 second">
      <div class="flex-grow-1 m-0 d-block p-0">
        <input
          class="border border-2 col-md-11 col-lg-8 d-block w-100 px-5 py-2 rounded-2 text-start"
          placeholder="Busque paciente ou laudo"
          type="text"

          v-on:keyup="search" ref="searchInput"
        />
        <svg class="ms-3 position-absolute start-0 top-0" height="16" style="fill: #808080 !important; margin-top: 12px;" viewBox="0 0 16 16" width="16">
          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
        </svg>
      </div>
      <div class="ms-auto mt-4 mt-md-0" v-if="this.$signedOnly === 'true' && this.state.lType !== 'tulPaciente' && this.state.lType !== 'tulPacienteCpf'">
        <div class="btn-group btn-group-sm">
          <input checked class="btn-check" id="btn-signed" name="btnradio" type="radio">
          <label class="btn btn-outline-primary-color rounded-start" for="btn-signed" @click="getUnsigned(false)">
            Com assinatura digital
          </label>

          <input class="btn-check" id="btn-not-signed" name="btnradio" type="radio">
          <label class="btn btn-outline-primary-color rounded-end" for="btn-not-signed" @click="getUnsigned(true)">
            Sem assinatura digital
          </label>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <div class="col-11 col-md-10 col-lg-9 col-xl-8 fadeIn third p-0" ref="atendimentosList">
        <div class="atendimento mt-4 rounded shadow user-select-none" v-for="(laudo) in laudos" :data-laudo="laudo.atend" :data-paciente="($signedOnly !== 'true' || unsignedAvailable) ? laudo.pacNome : laudo.paciente">
          <div class="d-lg-flex p-3">
            <div class="align-items-center col-12 col-lg-2 d-flex mb-3 mb-lg-0" v-if="$signedOnly !== 'true' || unsignedAvailable">
              <div v-if="laudo.faltaMaterial === 1">
                <div class="col-12 fw-light px-2 py-1 rounded text-bg-warning text-center">
                  Material faltante
                </div>
              </div>
              <div v-else>
                <div class="col-12 fw-light px-2 py-1 rounded text-bg-success text-center" v-if="laudo.status === 2">
                  Liberado
                </div>
                <div class="col-12 fw-light px-2 py-1 rounded text-bg-primary text-center" v-else-if="laudo.status === 1">
                  Parcial
                </div>
                <div class="col-12 fw-light px-2 py-1 rounded text-bg-danger text-center" v-else-if="laudo.status === 0">
                  Em andamento
                </div>
              </div>
            </div>
            <div class="align-items-center col-12 col-md-2 d-flex mb-3 mb-lg-0" v-else>
              <div class="col-12 fw-light px-2 py-1 rounded text-bg-success text-center" v-if="laudo.status === 'Liberado'">
                Liberado
              </div>
              <div class="col-12 fw-light px-2 py-1 rounded text-bg-danger text-center" v-else-if="laudo.status === 'Em andamento'">
                Em andamento
              </div>
              <div class="col-12 fw-light px-2 py-1 rounded text-bg-primary text-center" v-else="laudo.status === 'Parcial'">
                Parcial
              </div>
            </div>
            <div class="col-12 col-lg-5 ps-lg-5 ps-md-4 text-start">
              <p class="m-0 p-0">
                Paciente
              </p>
              <p class="fw-light m-0 mb-3 mb-lg-0" v-if="$signedOnly !== 'true' || unsignedAvailable">
                {{ laudo.pacNome }}
              </p>
              <p class="fw-light m-0 mb-3 mb-lg-0" v-else>
                {{ laudo.paciente }}
              </p>
            </div>
            <div class="col-12 col-lg-2 ps-md-4 text-start">
              <p class="m-0 p-0">
                Atendimento
              </p>
              <p class="fw-light m-0 mb-3 mb-lg-0">
                {{ laudo.atend }}
              </p>
            </div>
            <div class="align-items-center col-lg-3 d-flex">
              <div class="ms-lg-auto">
                <div class="border-0 btn btn-primary-color btn-sm ms-2 shadow-none" v-b-tooltip.hover.bottom :title="'Visualizado em ' + laudo.dtVisto" v-if="laudo.dtVisto && $signedOnly !== 'true'" style="cursor: default;">
                  <svg fill="currentColor" height="16" width="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"/>
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"/>
                  </svg>
                </div>
                <button class="border-0 btn btn-primary-color btn-sm ms-2 shadow-none text-white" title="Visualize os exames desta solicitação" v-b-tooltip.hover.bottom v-if="$signedOnly !== 'true' || unsignedAvailable" @click="getExamsList(laudo);">
                  Exames
                </button>
                <button class="border-0 btn btn-primary-color btn-sm ms-2 shadow-none text-white" title="Visualize os exames desta solicitação" v-b-tooltip.hover.bottom v-else @click="setExamsList(laudo.exames);">
                  Exames
                </button>
                <button class="border-0 btn btn-primary-color btn-sm ms-2 shadow-none text-white" title="Visualize o histórico de emissão de laudos desta solicitação" v-b-tooltip.hover.bottom @click="getReportsList(laudo);" v-if="$signedOnly === 'true' && !unsignedAvailable">
                  Hist&oacute;rico
                </button>
                <button class="border-0 btn btn-primary-color btn-sm ms-2 shadow-none" title="Realize o Download do último laudo emitido para esta solicitação" v-b-tooltip.hover.bottom @click="getReport(laudo);" v-if="($signedOnly === 'true' && !unsignedAvailable) || ($signedOnly === 'true' && !unsignedAvailable && $downloadUnsigned === 'true') || ($signedOnly !== 'true')">
                  <svg fill="currentColor" height="16" width="16" viewBox="0 0 16 16">
                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="bg-light border-top px-3 py-2 rounded-bottom text-start">
            <div class="d-lg-flex" v-if="$signedOnly !== 'true' || unsignedAvailable">
              <div class="col-12 col-lg-4 d-block mb-3 mb-lg-0 me-5">
                <p class="m-0 me-2">
                  Solicitante:
                </p>
                <p class="fw-light m-0">
                  {{ laudo.medNome }}
                </p>
              </div>
              <div class="col-12 col-lg-4 d-block mb-3 mb-lg-0">
                <p class="m-0 me-2">
                  Atendido em:
                </p>
                <p class="fw-light m-0">
                  {{ laudo.dtAtend }}
                </p>
              </div>
              <div class="col-12 col-lg-4 d-block mb-3 mb-lg-0">
                <p class="m-0 me-2">
                  Previs&atilde;o:
                </p>
                <p class="fw-light m-0">
                  {{ laudo.dtPrentAtend }}
                </p>
              </div>
            </div>
            <div class="d-lg-flex" v-else>
              <div class="col-12 col-lg-4 d-block mb-3 mb-lg-0 me-5">
                <p class="m-0 me-2">
                  Solicitante:
                </p>
                <p class="fw-light m-0">
                  {{ laudo.solicitante }}
                </p>
              </div>
              <div class="col-12 col-lg-4 d-block mb-3 mb-lg-0">
                <p class="m-0 me-2">
                  Atendido em:
                </p>
                <p class="fw-light m-0">
                  {{ laudo.dtAtend }}
                </p>
              </div>
              <div class="col-12 col-lg-4 d-block mb-3 mb-lg-0">
                <p class="m-0 me-2">
                  Visualizado em:
                </p>
                <p class="fw-light m-0">
                  {{ laudo.dtVisto }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer class="p-5"></footer>
  </div>
</template>

<script>
import { BModal } from "bootstrap-vue";
import { BTable } from "bootstrap-vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VuePdf from 'vue-pdf';

export default {
  name: "ListCmp",
  components: {
    bmodal: BModal,
    btable: BTable,
    VuePdf,
    PulseLoader,
  },
  data() {
    return {
      base64: null,
      examsModal: false,
      popupModal: false,
      isButtonDisabled: false,
      loading: false,
      passwordModal: false,
      reportsModal: false,
      unsignedAvailable: false,
      examsList: [],
      laudoList: [],
      reportsList: [],
      examsListModal: {
        centered: true,
        hideHeaderClose: true,
        noCloseOnBackdrop: true,
        size: "md",
        title: "Exames"
      },
      passwordChangeModal: {
        centered: true,
        hideHeaderClose: true,
        noCloseOnBackdrop: true,
        size: "md",
        title: "Redefinição de senha",
      },
      popupListModal: {
        centered: true,
        hideHeaderClose: true,
        noCloseOnBackdrop: true,
        size: "md",
        title: "Ops!"
      },
      reportsListModal: {
        centered: true,
        hideHeaderClose: true,
        noCloseOnBackdrop: true,
        scrollable: true,
        size: "lg",
        title: "Histórico de laudos"
      },
    };
  },
  computed: {
    acoes() {
      return this.$actions;
    },
    laudos() {
      return this.$store.laudos;
    },
    state() {
      return this.$store.state;
    }
  },
  mounted: function () {
    let _this = this;

    _this.checkLoginPat();

    const disabledTimestamp = localStorage.getItem(_this.state.id + ".buttonDisabledTimestamp");
    if (disabledTimestamp) {
      const currentTime = new Date().getTime();
      const twoHoursInMilliseconds = 2 * 60 * 60 * 1000;

      if (currentTime - disabledTimestamp < twoHoursInMilliseconds) {
        _this.isButtonDisabled = true;
      }
    }
  },
  methods: {
    changePassword() {
      let _this = this;

      let confirmPassword = _this.$refs.confirmPassword.value;
      let currentPassword = _this.$refs.currentPassword.value;
      let newPassword = _this.$refs.newPassword.value;
      let tpLogin = _this.state.lType;
      let username = _this.state.user;

      if (currentPassword && confirmPassword && newPassword) {
        if (newPassword !== currentPassword) {
          if (newPassword === confirmPassword) {
            axios
            .post("/v2/redefine-password", null, {
              params: {
                oldPassword: currentPassword,
                newPassword: newPassword,
                user: {
                  name: _this.state.user,
                  id: _this.state.id,
                },
                tpLogin: _this.state.lType,
              },
            })
            .then(function (response) {
              if (response.status === 200) {
                _this.$notify({
                  group: "alerts",
                  text: "Senha atualizada com sucesso!",
                  title: "Sucesso",
                  type: "success",
                });

                _this.state.password = newPassword;
                _this.handleResponse(_this.state.id);
              } else {
                _this.$notify({
                  group: "alerts",
                  text: "Ocorreu um erro ao atualizar a senha de acesso!",
                  title: "Erro",
                  type: "error",
                });

                return;
              }
            }).catch(function () {
              _this.$notify({
                group: "alerts",
                text: "A senha anterior não é válida!",
                title: "Erro",
                type: "error",
              });

              return;
            });

            if (_this.$signedOnly === "true") {
              axios
              .post("/v2/atualiza-senha", null, {
                params: {
                  COD101: currentPassword,
                  COD108: newPassword,
                  COD100: username,
                  COD106: tpLogin
                },
              })
              .then(function (response) {
                if (response.status === 200) {
                  _this.handleResponse(_this.state.id);
                } else {
                  _this.$notify({
                    group: "alerts",
                    text: "Ocorreu um erro ao atualizar a senha de acesso!",
                    title: "Erro",
                    type: "error",
                  });
                }
              }).catch(function () {
                _this.$notify({
                  group: "alerts",
                  text: "A senha anterior não é válida!",
                  title: "Erro",
                  type: "error",
                });
              });
            }

            _this.passwordModal = false;
          } else {
            _this.$notify({
              group: "alerts",
              text: "As senhas não coincidem!",
              title: "Atenção!",
              type: "warn",
            });
          }
        } else {
          _this.$notify({
            group: "alerts",
            text: "A nova senha não pode ser igual à senha anterior!",
            title: "Atenção!",
            type: "warn",
          });
        }
      } else {
        _this.$notify({
          group: "alerts",
          text: "Os dados necessários não foram informados!",
          title: "Atenção!",
          type: "warn",
        });
      }
    },
    checkLoginPat() {
      let _this = this;

      if (_this.state.lType == "tulPaciente" || _this.state.lType == "tulValidaHash") {
        _this.listPatAtends();
      }

      /*
      if (_this.state.lType === "tulPacienteCpf") {
        _this.listPatCpfAtends();
      }
        */
    },
    formatDate(dateString) {
      const date = new Date(dateString);

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
    getUnsigned(available) {
      let _this = this;

      _this.unsignedAvailable = available;

      if (_this.state.lType === "tulPaciente" || _this.state.lType === "tulValidaHash") {
        _this.listPatAtends();
      } else if (_this.state.lType === "tulPacienteCpf") {
        _this.listPatCpfAtends();
      } else {
        _this.searchLabRes();
      }
    },
    handleResponse(userID) {
      const disabledTimestamp = new Date().getTime();
      let _this = this;

      _this.isButtonDisabled = true;
      
      localStorage.setItem(userID + ".buttonDisabledTimestamp", disabledTimestamp);
      setTimeout(() => {
        _this.isButtonDisabled = false;
        localStorage.removeItem(userID + ".buttonDisabledTimestamp");
      }, 2 * 60 * 60 * 1000);
    },
    hideLoading() {
      let _this = this;

      _this.loading = false;
      _this.$refs.loading.classList.add("d-none");
      _this.$refs.loading.classList.remove("d-flex");
    },
    logout() {
      let _this = this;

      _this.acoes.setToken(_this.state);
      _this.$router.push("./");
    },
    openReport() {
      let _this = this;

      const binary = atob(_this.base64);
      console.log(_this.base64);
      const len = binary.length;
      const buffer = new ArrayBuffer(len);
      const view = new Uint8Array(buffer);

      for (let i = 0; i < len; i += 1) {
        view[i] = binary.charCodeAt(i);
      }
      
      const blob = new Blob([view], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      const pdfTab = window.open(url, "_blank");

      if (!pdfTab || pdfTab.closed || typeof pdfTab.closed === "undefined") {
        _this.$notify({
          group: "alerts",
          text: "O seu navegador está bloqueando a exibição dos laudos! Verifique as permissões do seu navegador.",
          title: "Atenção!",
          type: "error",
        });
      }
    },
    search() {
      let _this = this;

      let list = _this.$refs.atendimentosList;
      let search = _this.$refs.searchInput.value.toLowerCase();

      const children = list.querySelectorAll(".atendimento");
      children.forEach(child => {
        const laudo = child.getAttribute("data-laudo").toLowerCase();
        const paciente = child.getAttribute("data-paciente").toLowerCase();

        if (laudo.includes(search) || paciente.includes(search)) {
          child.classList.remove("d-none");
        } else {
          child.classList.add("d-none");
        }
      });
    },
    searchLabRes() {
      let _this = this;
      var ac = _this.acoes;

      let dataFinal = _this.$route.query.fim || '';
      let dataInicio = _this.$route.query.inicio || '';
      let filial = _this.$route.query.filial || '';
      let nLaudo = decodeURIComponent(_this.$route.query.laudo) || '';
      let nomePaciente = _this.$route.query.paciente || '';
      let password = _this.state.password;
      let procedencia = _this.$route.query.origem || '';
      let tpLogin = _this.state.lType;
      let userId = _this.state.id;
      let username = _this.state.user;

      if (dataFinal !== '' && dataInicio !== '') {
        _this.showLoading();

        if (_this.unsignedAvailable) {
          axios
          .get(
            "/v1/res" +
              "?COD24=" +
              userId +
              "&COD106=" +
              tpLogin +
              "&COD01=" +
              nomePaciente +
              "&COD21=" +
              dataInicio +
              "&COD22=" +
              dataFinal +
              "&COD09=" +
              nLaudo +
              "&COD23=" +
              filial +
              "&COD25=" +
              procedencia
          )
          .then(function (response) {
            if (response.status === 200) {
              var result = response.data.result;

              result.forEach((item) => {
                item.medNome = item.medNome.replace("null", "");

                // Apparently, for JavaScript null is
                // neither null or "null"
              });

              result.reverse();
              ac.setLaudos(result);
            } else {
              _this.hideLoading();
            }
          })
          .catch(function (error) {
            _this.$notify({
              group: "alerts",
              text: error,
              title: "Atenção!",
              type: "error",
            });
          })
          .finally(() => {
            _this.hideLoading();
          });
        } else {
          axios
          .get(
            "/v2/atendimento" +
            "?COD106=" +
            tpLogin +
            "&COD01=" +
            nomePaciente +
            "&COD21=" +
            dataInicio +
            "&COD22=" +
            dataFinal +
            "&COD09=" +
            nLaudo +
            "&COD101=" +
            username +
            "&COD100=" +
            password
          )
          .then(function (response) {
            const data = response.data.atendimentos;
            const laudos = [];

            Object.keys(data).forEach(key => {
              const idsmedreq = data[key];

              Object.keys(idsmedreq).forEach(idmedreq => {
                laudos.push({
                  idmedreq,
                  atend: key,
                  dtAtend: idsmedreq[idmedreq].data_atendimento,
                  dtVisto: idsmedreq[idmedreq].data_hora_visualizacao,
                  paciente: idsmedreq[idmedreq].paciente,
                  solicitante: idsmedreq[idmedreq].solicitante,
                  exames: idsmedreq[idmedreq].exames,
                  status: idsmedreq[idmedreq].status
                });
              });
            });

            _this.acoes.setLaudos(laudos);
          })
          .catch(function () {
            _this.$notify({
              group: "alerts",
              text: "Nenhum atendimento foi encontrado com os filtros informados",
              title: "Atenção!",
              type: "warn"
            });
          })
          .finally(() => {
            _this.hideLoading();
          });
        }
      } else {
        _this.$notify({
          group: "alerts",
          text: "Parâmetros de busca não informados corretamente",
          title: "Atenção!",
          type: "error"
        });
      }
    },
    setExamsList(exames) {
      let _this = this;

      _this.examsList = exames;
      _this.examsModal = true;
    },
    showLoading() {
      let _this = this;

      _this.loading = true;
      _this.$refs.loading.classList.add("d-flex");
      _this.$refs.loading.classList.remove("d-none");
    },
    async getExamsList(item) {
      let _this = this;

      let idFilial = item.atend.split(".")[1].split("/")[0];
      let idMedReq = item.idMedReq;
      let nrLaudo = item.atend;
      let password = _this.state.password;
      let tpLogin = _this.state.lType;
      let username = _this.state.user;

      _this.showLoading();

      await axios
        .get(
          "/v1/atendimentos" +
          "?COD104=" +
          idFilial +
          "&COD106=" +
          tpLogin +
          "&COD101=" +
          username +
          "&COD100=" +
          password +
          "&COD130=" +
          item.pacNome +
          "&COD131=" +
          nrLaudo
        )
        .then(function (response) {
          if (response.status === 200) {
            var xml = response.data.msg.Resultado.$value;

            const parser = new DOMParser();
            const doc = parser.parseFromString(xml, "application/xml");
            const errorNode = doc.querySelector("parsererror");

            if (!errorNode) {
              _this.examsList = [];

              var appointmentsList = doc.all[0].children;
              var status;
              
              appointmentsList = [...appointmentsList];
              appointmentsList.forEach((e) => {
                if (e.children[3].textContent === idMedReq.toString()) {
                  var mednome = e.children[5].textContent;

                  var examsList = e.getElementsByTagName("listaExames");
                  examsList = [...examsList];

                  examsList.forEach((e) => {
                    var exams = e.children;
                    exams = [...exams];

                    exams.forEach((e) => {
                      if (e.children[2].textContent.replace("tse", "") === "Nenhum") {
                        status = "Em andamento";
                      } else {
                        status = e.children[2].textContent.replace("tse", "");
                      }

                      _this.examsList.push({
                        descricao: e.children[1].textContent,
                        solicitante: mednome,
                        status: status
                      });
                    });
                  });
                }
              });

              _this.laudoList = item;
              _this.examsModal = true;
            } else {
              _this.$notify({
                group: "alerts",
                text: response.data.msg.Mensagem.$value,
                title: "Atenção",
                type: "error",
              });
            }
          } else {
            _this.$notify({
              group: "alerts",
              text: response.data.msg.Mensagem.$value,
              title: "Atenção",
              type: "error",
            });
          }
        })
        .finally(() => {
          _this.hideLoading();
        });
    },
    async getReport(item) {
      let _this = this;

      let idmedreq = item.idmedreq;
      let nrLaudo = item.atend;
      let password = _this.state.password;
      let tpLogin = _this.state.lType;
      let username = _this.state.user;
      let idLaudo = item.id || '';

      var now = new Date();

      var day = String(now.getDate()).padStart(2, "0");
      var month = String(now.getMonth() + 1).padStart(2, "0");
      var year = now.getFullYear();
      var hour = String(now.getHours()).padStart(2, "0");
      var minute = String(now.getMinutes()).padStart(2, "0");
      var seconds = String(now.getSeconds()).padStart(2, "0");

      _this.showLoading();

      if (_this.$signedOnly !== 'true' || _this.unsignedAvailable) {
        axios
        .get(
          "/v1/laudo-pdf" +
          "?COD103=" +
          nrLaudo.split(".")[0] +
          "&COD104=" +
          nrLaudo.split(".")[1].split("/")[0] +
          "&COD102=" +
          "20" +
          nrLaudo.split(".")[1].split("/")[1] +
          "&COD105=" +
          item.req +
          "&COD106=" +
          _this.state.lType +
          "&COD101=" +
          _this.state.user +
          "&COD100=" +
          _this.state.password
        )
        .then(function (response) {
          if (response.status === 200) {
            var pdf = response.data.msg.$value;

            try {
              if (pdf === "" || pdf === undefined) {
                _this.$notify({
                  group: "alerts",
                  type: "warn",
                  title: "Atenção!",
                  text: "Em Andamento, ainda não há resultados liberados para consulta!",
                });
              } else {
                _this.base64 = pdf.replace(/\s/g, "");

                const binary = atob(_this.base64);
                const len = binary.length;
                const buffer = new ArrayBuffer(len);
                const view = new Uint8Array(buffer);

                for (let i = 0; i < len; i += 1) {
                  view[i] = binary.charCodeAt(i);
                }

                const blob = new Blob([view], { type: "application/pdf" });
                const url = URL.createObjectURL(blob);

                const pdfTab = window.open(url, "_blank");

                if (!pdfTab || pdfTab.closed || typeof pdfTab.closed === "undefined") {
                  _this.popupModal = true;
                } else {
                  _this.base64 = null;
                }

                item.dtVisto = `${day}/${month}/${year} ${hour}:${minute}:${seconds}`;
              }
            } catch (error) {
              _this.$notify({
                group: "alerts",
                text: "Ocorreu um erro ao gerar o laudo solicitado!",
                title: "Atenção!",
                type: "error"
              });
              
              console.error(error);
            }
          } else {
            _this.$notify({
              group: "alerts",
              text: "Não foi possível buscar o laudo solicitado!",
              title: "Atenção!",
              type: "error"
            });

            console.error(response);
          }
        })
        .finally(() => {
          _this.hideLoading();
        });
      } else {
        try {
          await axios
          .get(
            "/v2/atendimento/laudo" +
            "?COD09=" + nrLaudo +
            "&COD100=" + password +
            "&COD101=" + username +
            "&COD105=" + idmedreq +
            "&COD106=" + tpLogin +
            "&COD107=" + idLaudo
          )
          .then(function(response) {
            try {
              const data = response.data.pdf;
              
              const binaryString = atob(data);
              const length = binaryString.length;
              const bytes = new Uint8Array(length);

              for (let i = 0; i < length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
              }

              const blob = new Blob([bytes], { type: "application/pdf" });
              const url = URL.createObjectURL(blob);

              const pdfTab = window.open(url, "_blank");

              if (!pdfTab || pdfTab.closed || typeof pdfTab.closed === "undefined") {
                _this.base64 = data;
	              _this.popupModal = true;
              } else {
	              _this.base64 = null;
              }
            } catch {
              _this.$notify({
                group: "alerts",
                text: "Em andamento, ainda não há resultados liberados para consulta!",
                title: "Atenção!",
                type: "warn"
              });
            }
          })
        } catch (error) {
          _this.$notify({
            group: "alerts",
            text: error.response.data.message,
            title: "Atenção!",
            type: error.response.data.code === "404" ? "warn" : "error"
          });
        } finally {
          _this.hideLoading();
        }
      }
    },
    async getReportsList(item) {
      let _this = this;

      let idmedreq = item.idmedreq;
      let nrLaudo = item.atend;
      let password = _this.state.password;
      let tpLogin = _this.state.lType;
      let username = _this.state.user;

      _this.showLoading();

      try {
        await axios
        .get(
          "/v2/atendimento/laudos" +
          "?COD09=" + nrLaudo +
          "&COD100=" + password +
          "&COD101=" + username +
          "&COD105=" + idmedreq +
          "&COD106=" + tpLogin
        )
        .then(function(response) {
          const data = response.data.laudos;

          _this.reportsList = Object.entries(data).map(([idlaudosdoc, laudo]) => ({
            idlaudosdoc,
            ...laudo,
            idmedreq: idmedreq,
            atend: nrLaudo
          }));

          _this.reportsModal = true;
        })
      } catch (error) {
        _this.$notify({
          group: "alerts",
          text: error.response.data.message,
          title: "Atenção!",
          type: error.response.data.code === "404" ? "warn" : "error"
        });
      } finally {
        _this.hideLoading();
      }
    },
    async listPatAtends() {
      let _this = this;

      let ac = _this.acoes;
      var username = _this.state.user;
      var password = _this.state.password;
      var tpLogin = _this.state.lType;

      var filial = tpLogin !== 'tulValidaHash'
        ? _this.state.user.split(".")[1].split("/")[0]
        : 1;

      _this.showLoading();

      if (_this.$signedOnly !== "true" || _this.unsignedAvailable) {
        await axios
        .get(
          "/v1/atendimentos" +
          "?COD104=" +
          filial +
          "&COD106=" +
          tpLogin +
          "&COD101=" +
          username +
          "&COD100=" +
          password
        )
        .then(function (response) {
          if (response.status === 200) {
            var xml = response.data.msg.Resultado.$value;

            const parser = new DOMParser();
            const doc = parser.parseFromString(xml, "application/xml");
            const errorNode = doc.querySelector("parsererror");

            if (!errorNode) {
              var l = [];
              var listAtends = doc.all[0].children;

              for (const el of listAtends) {
                var idAtend = el.getElementsByTagName("idAtend")[0].textContent;
                var idFilial = el.getElementsByTagName("idFilial")[0].textContent;
                var atnAno = el.getElementsByTagName("atnAno")[0].textContent;
                var idMedReq = el.getElementsByTagName("idMedReq")[0].textContent;
                var medAbr = el.getElementsByTagName("medAbr")[0].textContent;
                var medNome = el.getElementsByTagName("medNome")[0].textContent;
                var pacNome = el.getElementsByTagName("pacNome")[0].textContent;
                var dtAtend = el.getElementsByTagName("atnDtAtend")[0].textContent.split(" ")[0];
                var lstEms = el.getElementsByTagName("listaExames")[0].children;
                var faltaMaterialTag = el.getElementsByTagName("atnFaltaMat")[0];
                var faltaMaterial;

                if (faltaMaterialTag) {
                  faltaMaterial = faltaMaterialTag.textContent;
                }

                var atndhprent = el.getElementsByTagName("atnDhPRent");
                var dtPrevAtend = atndhprent.length > 0 ? atndhprent[0].textContent : "";

                var atndhentug = el.getElementsByTagName("atnDhEntUg");
                var dtEntUg = atndhentug.length > 0 ? atndhentug[0].textContent : "";

                var atndhvisto = el.getElementsByTagName("atnDhVisto");
                var dtVisto = atndhvisto.length > 0 ? atndhvisto[0].textContent : "";

                if (!el.getElementsByTagName("listaExames").length) {
                  continue;
                }

                var dtPrentAtend = null;
                if (dtPrevAtend != "") {
                  dtPrentAtend = dtPrevAtend;
                } else {
                  dtPrentAtend = dtEntUg;
                }

                var atend = idAtend + "." + idFilial + "/" + atnAno.slice(2, 4);
                var estatus = -1;
                let lEmsStatus = "";
                var resLib = -1;
                var resLibStr = "";

                for (const ems of lstEms) {
                  lEmsStatus = ems.getElementsByTagName("emsStatus")[0].textContent.replace("tse", "");
                  if (lEmsStatus === "Liberado") {
                    resLibStr = resLibStr + "0";
                  } else {
                    resLibStr = resLibStr + "1";
                  }
                }

                if (resLibStr.includes("0")) {
                  estatus = 0;
                  resLib = 0;
                }

                if (resLibStr.includes("1")) {
                  if (estatus === 0) {
                    resLib = 1;
                  } else {
                    resLib = 0;
                  }
                } else {
                  resLib = 2; // totalmente liberado
                }

                if (medNome != null) {
                  medNome = medAbr + " " + medNome
                }

                var lObj = {
                  dtAtend: dtAtend,
                  dtPrentAtend: dtPrentAtend,
                  dtVisto: dtVisto,
                  atend: atend,
                  pacNome: pacNome,
                  idMedReq: idMedReq,
                  medNome: medNome,
                  req: idMedReq,
                  status: resLib,
                  faltaMaterial: faltaMaterial
                };

                l.push(lObj);
              }
              
              ac.setLaudos(l);
            }
          }
        });
      } else {
        try {
          await axios
          .get(
            "/v2/atendimento" +
            "?COD106=" +
            tpLogin +
            "&COD101=" +
            username +
            "&COD100=" +
            password
          )
          .then(function (response) {
            const data = response.data.atendimentos;
            const laudos = [];

            Object.keys(data).forEach(key => {
              const idsmedreq = data[key];

              Object.keys(idsmedreq).forEach(idmedreq => {
                laudos.push({
                  idmedreq,
                  atend: key,
                  dtAtend: idsmedreq[idmedreq].data_atendimento,
                  dtVisto: idsmedreq[idmedreq].data_hora_visualizacao,
                  paciente: idsmedreq[idmedreq].paciente,
                  solicitante: idsmedreq[idmedreq].solicitante,
                  exames: idsmedreq[idmedreq].exames,
                  status: idsmedreq[idmedreq].status
                });
              });
            });

            _this.acoes.setLaudos(laudos);
          });
        } catch (error) {
          _this.$notify({
            group: "alerts",
            text: error.response.data.message,
            title: "Atenção!",
            type: error.response.data.code === "404" ? "warn" : "error"
          });
        }
      }

      _this.hideLoading();
    },
    async listPatCpfAtends() {
      let _this = this;

      let ac = _this.acoes;
      var filial = null;
      var password = _this.state.password;
      var tpLogin = _this.state.lType;
      var username = _this.state.user;

      _this.showLoading();

      if (_this.$signedOnly !== "true" || _this.unsignedAvailable) {
        await axios
        .get(
          "/v1/atendimentos" +
          "?COD104=" +
          filial +
          "&COD106=" +
          tpLogin +
          "&COD101=" +
          username +
          "&COD100=" +
          password
        )
        .then(function (response) {
          if (response.status === 200) {
            var xml = response.data.msg.Resultado.$value;

            const parser = new DOMParser();
            const doc = parser.parseFromString(xml, "application/xml");
            const errorNode = doc.querySelector("parsererror");

            if (!errorNode) {
              var l = [];
              var listAtends = Array.from(doc.all[0].children);
              
              for (const el of listAtends) {
                var idAtend = el.getElementsByTagName("idAtend")[0].textContent;
                var idFilial = el.getElementsByTagName("idFilial")[0].textContent;
                var atnAno = el.getElementsByTagName("atnAno")[0].textContent;
                var idMedReq = el.getElementsByTagName("idMedReq")[0].textContent;
                var medAbr = el.getElementsByTagName("medAbr")[0].textContent;
                var medNome = el.getElementsByTagName("medNome")[0].textContent;
                var pacNome = el.getElementsByTagName("pacNome")[0].textContent;
                var dtAtend = el.getElementsByTagName("atnDtAtend")[0].textContent.split(" ")[0];
                var lstEms = el.getElementsByTagName("listaExames")[0].children;
                var faltaMaterialTag = el.getElementsByTagName("atnFaltaMat")[0];
                var faltaMaterial;

                if (faltaMaterialTag) {
                  faltaMaterial = faltaMaterialTag.textContent;
                }

                var atndhprent = el.getElementsByTagName("atnDhPRent");
                var dtPrevAtend = atndhprent.length > 0 ? atndhprent[0].textContent : "";

                var atndhentug = el.getElementsByTagName("atnDhEntUg");
                var dtEntUg = atndhentug.length > 0 ? atndhentug[0].textContent : "";

                var atndhvisto = el.getElementsByTagName("atnDhVisto");
                var dtVisto = atndhvisto.length > 0 ? atndhvisto[0].textContent : "";

                var dtPrentAtend = null;
                if (dtPrevAtend != "") {
                  dtPrentAtend = dtPrevAtend;
                } else {
                  dtPrentAtend = dtEntUg;
                }

                if (!el.getElementsByTagName("listaExames").length) {
                  continue;
                }
                
                var atend = idAtend + "." + idFilial + "/" + atnAno.slice(2, 4);
                var estatus = -1;
                let lEmsStatus = "";
                var resLib = -1;
                var resLibStr = "";

                for (const ems of lstEms) {
                  lEmsStatus = ems.getElementsByTagName("emsStatus")[0].textContent.replace("tse", "");
                  if (lEmsStatus === "Liberado") {
                    resLibStr = resLibStr + "0";
                  } else {
                    resLibStr = resLibStr + "1";
                  }
                }

                if (resLibStr.includes("0")) {
                  estatus = 0;
                  resLib = 0;
                }

                if (resLibStr.includes("1")) {
                  if (estatus === 0) {
                    resLib = 1;
                  } else {
                    resLib = 0;
                  }
                } else {
                  resLib = 2; // totalmente liberado
                }

                if (medNome != null) {
                  medNome = medAbr + " " + medNome
                }

                var lObj = {
                  dtAtend: dtAtend,
                  dtPrentAtend: dtPrentAtend,
                  dtVisto: dtVisto,
                  atend: atend,
                  pacNome: pacNome,
                  medNome: medNome,
                  idMedReq: idMedReq,
                  req: idMedReq,
                  status: resLib,
                  faltaMaterial: faltaMaterial
                };

                l.push(lObj);
              }

              l.sort((start, end) => {
                const startDate = new Date(start.dtAtend);
                const endDate = new Date(end.dtAtend);

                if (isNaN(startDate) || isNaN(endDate)) {
                  return isNaN(startDate) ? 1 : -1;
                }

                return endDate - startDate;
              });

              l.reverse();
              ac.setLaudos(l);
            }
          }
        });
      } else {
        try {
          await axios
          .get(
            "/v2/atendimento" +
            "?COD106=" +
            tpLogin +
            "&COD101=" +
            username +
            "&COD100=" +
            password
          )
          .then(function (response) {
            const data = response.data.atendimentos;
            const laudos = [];

            Object.keys(data).forEach(key => {
              const idsmedreq = data[key];

              Object.keys(idsmedreq).forEach(idmedreq => {
                laudos.push({
                  idmedreq,
                  atend: key,
                  dtAtend: idsmedreq[idmedreq].data_atendimento,
                  dtVisto: idsmedreq[idmedreq].data_hora_visualizacao,
                  paciente: idsmedreq[idmedreq].paciente,
                  solicitante: idsmedreq[idmedreq].solicitante,
                  exames: idsmedreq[idmedreq].exames,
                  status: idsmedreq[idmedreq].status
                });
              });
            });

            _this.acoes.setLaudos(laudos);
          });
        } catch (error) {
          _this.$notify({
            group: "alerts",
            text: error.response.data.message,
            title: "Atenção!",
            type: error.response.data.code === "404" ? "warn" : "error"
          });
        }
      }

      _this.hideLoading();
    }
  }
};
</script>

<style scoped></style>